const state = {
  currentOpt: 0,
  isMarked: false,
  isPointPanel: false,
  selectTime: "",
  taskType: 0,
  taskTool: 0,
};

export default state;
